import { render, staticRenderFns } from "./IncomeViewModal.vue?vue&type=template&id=08e7cfbc&"
import script from "./IncomeViewModal.vue?vue&type=script&lang=js&"
export * from "./IncomeViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports